import get from 'lodash/get';
import {connect} from 'react-redux';
import partial from 'lodash/partial';
import {createSelector} from 'reselect';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import {saveResourceFieldAction} from 'resources/actions';
import {createResourceSelector, createAutoSaveStatusSelector} from 'resources/selectors';
import PrizeDrawInfo from './PrizeDrawInfo';
import {getInitialDrawDate} from './utils';

// returns the auto-save statuses of a given prize's weekly draw dates.
const createDrawDateStatusesSelector = prizeId => createSelector(
  resources => resources,
  createResourceSelector(prizeId),
  (resources, prize) => get(prize, 'drawInfo', []).map((_, index) => {
    const getAutoSaveStatuses = createAutoSaveStatusSelector(`${prizeId}drawInfo.${index}.drawDate`);
    return getAutoSaveStatuses(resources);
  })
);

// returns the auto-save status of a newly-created weekly draw date. the wrapped
// PrizeDrawInfo component only allows one new drawDate to be created at a time, so this
// selector assumes in kind that there is only one in the store.
const createNewDrawDateStatusSelector = prizeId => createSelector(
  resources => resources,
  createAutoSaveStatusSelector(`${prizeId}drawInfo.#`)
);

const mapStateToProps = state => {
  const {currentPrizeId} = state.editPrize;
  const getPrize = createResourceSelector(currentPrizeId);
  const getSaveStatuses = createDrawDateStatusesSelector(currentPrizeId);
  const getNewDrawDateStatus = createNewDrawDateStatusSelector(currentPrizeId);

  return {
    prize: getPrize(state.resources),
    saveStatuses: getSaveStatuses(state.resources),
    newDrawDateStatus: getNewDrawDateStatus(state.resources)
  };
};

const mapDispatchToProps = {
  saveResourceField: saveResourceFieldAction
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => {
    const saveField = (field, value) => props.saveResourceField(
      props.prize.resourceId,
      props.prize.resourceId,
      [],
      [field],
      field,
      value,
      [props.prize.resourceId]
    );

    // save calls on this field have a special shorthand syntax for
    // adding/editing/deleting list items:
    //
    //  +--------------------------------------+
    //  | syntax      | action                 |
    //  |-------------+------------------------|
    //  | drawInfo.#  | create item            |
    //  | drawInfo.1  | edit item at index 1   |
    //  | drawInfo.X1 | delete item at index 1 |
    //  +--------------------------------------+
    //
    return {
      // must provide the full (serialized) object to the API on create.
      onAddItem: () => saveField('drawInfo.#', JSON.stringify({
        // drawDate: null
        drawDate: getInitialDrawDate(props.prize)
      })),

      onRemoveItem: index => saveField(`drawInfo.X${index}`),
      onValueChanged: (index, value) => saveField(`drawInfo.${index}.drawDate`, value)
    };
  })
)(PrizeDrawInfo);



// WEBPACK FOOTER //
// ./public/pages/EditPrize/PrizeDrawInfoContainer.js